(function () { 
angular.module('invesfleet')
    .directive('anchor', anchor);

    anchor.$inject = ['$location', '$anchorScroll', '$timeout'];

    function anchor($location, $anchorScroll, $timeout) {
        
        return {
            restrict: 'A',
            scope: {
                anchor: '@'
            },
            link: function(scope, element, attrs){
                element.bind('click', function () {

                    //We save the old hash and restore it because changing it causes a reload
                    var old = $location.hash();

                    $location.hash(scope.anchor);
                    $anchorScroll.yOffset = 148;
                    $anchorScroll();

                    $location.hash(old);

                });
            }
        };
    }
})();